import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useSaveLabOrder() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((labOrderId, payload) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = labOrderId
      ? quarkusApi.put(`/lab-orders/${labOrderId}`, payload, authHeader)
      : quarkusApi.post('/lab-orders', payload, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
